export { EloMailFillIcon } from './mail-fill-icon'
